var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Children, cloneElement } from 'react';
import { InlineError } from '@guardian/src-user-feedback';
import { descriptionId, generateSourceId, } from '@guardian/src-foundations/accessibility';
import { Legend } from '@guardian/src-label';
import { fieldset } from './styles';
export const CheckboxGroup = (_a) => {
    var { id, name, label, hideLabel, supporting, error, cssOverrides, children } = _a, props = __rest(_a, ["id", "name", "label", "hideLabel", "supporting", "error", "cssOverrides", "children"]);
    const groupId = id || generateSourceId();
    const legend = label ? (_jsx(Legend, { text: label, supporting: supporting, hideLabel: hideLabel }, void 0)) : ('');
    const message = typeof error === 'string' ? (_jsx(InlineError, Object.assign({ id: descriptionId(groupId) }, { children: error }), void 0)) : ('');
    return (_jsxs("fieldset", Object.assign({ css: [fieldset, cssOverrides], id: groupId }, props, { children: [legend, message, Children.map(children, (child) => {
                return cloneElement(child, Object.assign(error
                    ? {
                        error: true,
                        'aria-describedby': descriptionId(groupId),
                    }
                    : {}, {
                    name,
                }));
            })] }), void 0));
};
//# sourceMappingURL=CheckboxGroup.js.map
